module.exports = __webpack_public_path__ + "static/media/compose_dark.9e592957.svg";